"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighscoreModule = void 0;
var referral_game_api_1 = require("../../../api/referral-game-api");
var object_service_1 = require("../../../object-service");
var referral_game_helper_service_1 = require("../services/referral-game-helper.service");
var HighscoreModule = /** @class */ (function () {
    function HighscoreModule() {
        this.referralGame = object_service_1.ObjectService.getInstance(referral_game_api_1.ReferralGameAPI);
        this.vanillaGenerator = object_service_1.ObjectService.getInstance(referral_game_helper_service_1.VanillaGenerator);
        this.oldSearch = undefined;
    }
    HighscoreModule.prototype.loadModule = function (module, settings) {
        return __awaiter(this, void 0, void 0, function () {
            var numberOfPlayers, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.settings = settings;
                        this.vanillaGenerator.createLoadingScreen();
                        if (settings === null || settings === void 0 ? void 0 : settings.searchField) {
                            this.createSearchField();
                        }
                        this.customerRef = document.querySelector('[data-ref="customer"]');
                        this.parentWrapper = this.customerRef.parentNode;
                        this.customerRef.style.display = 'none';
                        document.body.appendChild(this.customerRef);
                        this.highlightRef = document.querySelector('[data-ref="highlight"]');
                        this.highlightRef.style.display = 'none';
                        document.body.appendChild(this.highlightRef);
                        return [4 /*yield*/, this.referralGame.getNumberOfPlayersForGame(this.settings.gameId)];
                    case 1:
                        numberOfPlayers = _b.sent();
                        return [4 /*yield*/, this.loadCounter(numberOfPlayers)];
                    case 2:
                        _b.sent();
                        _a = this;
                        return [4 /*yield*/, this.referralGame.getHighscoresForGame(this.settings.gameId)];
                    case 3:
                        _a.leaderBoard = _b.sent();
                        this.loadLeaderBoard(this.leaderBoard);
                        this.vanillaGenerator.deleteLoadingScreen();
                        return [2 /*return*/];
                }
            });
        });
    };
    HighscoreModule.prototype.loadCounter = function (numberOfPlayers) {
        return __awaiter(this, void 0, void 0, function () {
            var data, content;
            return __generator(this, function (_a) {
                data = String((numberOfPlayers === null || numberOfPlayers === void 0 ? void 0 : numberOfPlayers.totalCount) || 0);
                content = document.querySelector('[data-get="total-active-players"]').innerHTML;
                document.querySelector('[data-get="total-active-players"]').innerHTML = (content === null || content === void 0 ? void 0 : content.includes('{{data}}')) ? content.replace(/\{\{data\}\}/gi, data) : data;
                return [2 /*return*/];
            });
        });
    };
    HighscoreModule.prototype.loadLeaderBoard = function (users) {
        return __awaiter(this, void 0, void 0, function () {
            var index, _loop_1, this_1, _i, users_1, customer;
            return __generator(this, function (_a) {
                console.log(users);
                this.parentWrapper.innerHTML = '';
                index = 0;
                _loop_1 = function (customer) {
                    index++;
                    var clone = (customer.placement === 1 ? this_1.highlightRef : this_1.customerRef).cloneNode(true);
                    var getter = clone.querySelectorAll('[data-get]');
                    if (getter === null || getter === void 0 ? void 0 : getter.length) {
                        getter.forEach(function (a) {
                            var _a;
                            var attr = a.getAttribute('data-get');
                            if (attr === 'index') {
                                a.innerHTML = String(index) + '.';
                            }
                            else if (attr) {
                                a.innerHTML = (_a = customer === null || customer === void 0 ? void 0 : customer[attr]) !== null && _a !== void 0 ? _a : '';
                            }
                        });
                    }
                    clone.style.display = null;
                    this_1.parentWrapper.appendChild(clone);
                };
                this_1 = this;
                for (_i = 0, users_1 = users; _i < users_1.length; _i++) {
                    customer = users_1[_i];
                    _loop_1(customer);
                }
                return [2 /*return*/];
            });
        });
    };
    HighscoreModule.prototype.createSearchField = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.searchField = document.querySelector('[data-ref="searchfield"]');
                this.searchField.addEventListener('keydown', function (event) {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                    _this.performSearch(_this.searchField.value);
                });
                this.searchField.addEventListener('keyup', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    _this.performSearch(_this.searchField.value);
                });
                this.searchField.addEventListener('change', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    _this.performSearch(_this.searchField.value);
                });
                return [2 /*return*/];
            });
        });
    };
    HighscoreModule.prototype.performSearch = function (search) {
        return __awaiter(this, void 0, void 0, function () {
            var searchRes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log(search);
                        if (!(search.length > 0 && search !== (this === null || this === void 0 ? void 0 : this.oldSearch))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.referralGame.searchForUser(this.settings.gameId, search)];
                    case 1:
                        searchRes = _a.sent();
                        this.parentWrapper.innerHTML = '';
                        this.loadLeaderBoard(searchRes);
                        console.log(searchRes);
                        this.oldSearch = search;
                        return [3 /*break*/, 3];
                    case 2:
                        this.loadLeaderBoard(this.leaderBoard);
                        this.oldSearch = undefined;
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return HighscoreModule;
}());
exports.HighscoreModule = HighscoreModule;
